/**
 * lib/supabaseClient.js
 * Helper to initialize the Supabase client.
 */

import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://qitxcdtkwmhepzchyxxb.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFpdHhjZHRrd21oZXB6Y2h5eHhiIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzU5NjUzODUsImV4cCI6MTk5MTU0MTM4NX0.PRoKN82P6BKBdPKp-8Tcm4epRWax1eHH515VN16fuII'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)




// WEBPACK FOOTER //
// ./src/libs/supabaseClient.js